import API from "../config/api";
import { Store } from "../redux/store";

const GET = async (url: any, params: any) => {
  const User: any = Store.getState().User;
  const token = User.token;
  return new Promise(async (resolve, reject) => {
    try {
      console.log("Making GET request to:", API.BASE_URL + url);
      console.log("Token:", token ? "Present" : "Missing");
      
      const response = await fetch(API.BASE_URL + url, {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      
      if (!response.ok) {
        console.error("HTTP Error:", response.status, response.statusText);
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const json = await response.json();
      console.log("GET response:", json);
      resolve(json);
    } catch (error) {
      console.error("GET request failed:", error);
      reject(error);
    }
  });
};

const POST = async (url: any, body: any) => {
    const User: any = Store.getState().User;
  const token = User.token;
  return new Promise(async (resolve, reject) => {
    try {
      console.log("Making POST request to:", API.BASE_URL + url);
      console.log("Token:", token ? "Present" : "Missing");
      console.log("Request body:", body);
      
      const response = await fetch(API.BASE_URL + url, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });
      
      if (!response.ok) {
        console.error("HTTP Error:", response.status, response.statusText);
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const json = await response.json();
      console.log("POST response:", json);
      resolve(json);
    } catch (error) {
      console.error("POST request failed:", error);
      reject(error);
    }
  });
};

const FORGETPASSWORD = async (url: any, body: any) => {
  return new Promise(async (resolve, reject) => {
    fetch( API?.BASE_URL + url, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer `,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((json) => {
        resolve(json);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const POST2 = async (url: any, body: any) => {
  const User = Store.getState().User;
  const token: any = User.token;
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(API.BASE_URL + url, {
        method: "post",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: body,
      });
      const json = await response.json();
      resolve(json);
    } catch (error) {
      reject(error);
    }
  });
};

const PUT = async (url: any, body: any) => {
  const User: any = Store.getState().User;
  const token = User.token;
  return new Promise(async (resolve, reject) => {
    fetch(API.BASE_URL + url, {
      method: "put",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())

      .then((json) => {
        resolve(json);
      })

      .catch((error) => {
        reject(error);
      });
  });
};

const DELETE = async (url: any) => {
  const User: any = Store.getState().User;
  const token = User.token;
  return new Promise(async (resolve, reject) => {
    fetch(API.BASE_URL + url, {
      method: "delete",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((json) => {
        resolve(json);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const UPLOADEXCEL = async (url: any, formData: any) => {
  const User: any = Store.getState().User;
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(API.BASE_URL + url, {
        method: "POST",
        body: formData,
      });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

const COMPRESS_IMAGE = async (file: any) => {
  const User: any = Store.getState().User;
  return new Promise(async (resolve, reject) => {
    try {
      if (file) {
        const formData = new FormData();
        formData.append("file", file);
        const response = await fetch(`${API.BASE_URL}img_compress/compress`, {
          method: "POST",
          body: formData,
        });
        if (response.ok) {
          const jsonResponse: any = await response.json();
          const obj = {
            ...jsonResponse,
            url: jsonResponse.Location,
            status: true,
          };
          resolve(obj);
        } else {
          let obj = {
            status: false,
            url: null,
          };
          reject(obj);
        }
      } else {
        reject("no file selected");
      }
    } catch (err) {
      reject(err);
    }
  });
};

export {
  GET,
  POST,
  PUT,
  DELETE,
  POST2,
  UPLOADEXCEL,
  COMPRESS_IMAGE,
  FORGETPASSWORD
};
